import { render, staticRenderFns } from "./playerTable.vue?vue&type=template&id=62d636d8&scoped=true"
import script from "./playerTable.vue?vue&type=script&lang=js"
export * from "./playerTable.vue?vue&type=script&lang=js"
import style0 from "./playerTable.vue?vue&type=style&index=0&id=62d636d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d636d8",
  null
  
)

export default component.exports